import React, { useEffect, useState } from "react";
import offer from "../../../assets/Offer.svg";
import CourseSlider from "./Sliders/MentorSlider";
import { Course_bundle } from "../../../Mock/Learn";
import axios from "axios";
import Timer from "../../../main/Timer/Timer";

import Loading from "../../../utils/Loader/Loading";

const CourseBundle = ({ id }) => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/multi_course_get/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  console.log(state);

  return (
    <>
      {isLoading && (
        <div className="my-50 flex justify-center items-center h-screen">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && state.length !== 0 && (
        <section className=" max-w-7xl m-auto mt-16 max-sm:px-5">
          <div className="flex justify-center items-center gap-4">
            <div className=" text-[#FFFF01] text-xs font-medium  flex items-center max-w-28 w-full justify-center relative max-sm:hidden ">
              <img src={offer} alt="img" />
              <span className="block text-[0.7rem] w-20 italic absolute  text-center">
                Bundle and Save Now!
              </span>
            </div>
            <h1 className="text-textColor font-semibold text-4xl max-w-md leading-[60px] text-center max-sm:text-xl">
              Save Big with Our Course Bundle!
            </h1>
            <div className=" text-[#FFFF01] text-xs font-medium  flex items-center max-w-28 w-full justify-center relative  max-sm:hidden">
              <img src={offer} alt="img" />
              <span className="block text-[0.7rem] w-20 italic absolute  text-center">
                Bundle and Save Now!
              </span>
            </div>
          </div>
          <div className="relative mt-10">
            <div className="max-w-6xl m-auto">
              <CourseSlider data={state} />
            </div>
          </div>
          <Timer />
        </section>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default CourseBundle;
